// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608180434/js/" + chunkId + "." + {"44":"6abcf16d","225":"c4608bb2","481":"e7bb28b8","486":"632f2ef1","770":"7cbb8cfa"}[chunkId] + ".0.5911902731346854.chunk.js";
};